<template>
  <div>
    <div v-show="bfloag1" class="overlay"></div>
    <div class="BlockList-W" v-show="bfloag">
      <img
        class="imgs"
        src="../../../assets/pc/Login/close.png"
        @click="close"
      />
      <div class="logintit">Bind wallet address</div>
      <div class="logintit1">
        USDT/DO locking must be done through a<br />
        personal wallet and cannot be done directly <br />through an exchange;
        otherwise, you will not<br />
        be able to receive PRL-X.
      </div>
      <div class="loginbox">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="putext" style="margin-top: 20px">
            <div class="bindtit">
              <div class="dian">.</div>
              USDT Lock-up Address:
            </div>
            <el-form-item prop="donationAddress">
              <el-input
                v-model.trim="form.donationAddress"
                class="inpttext"
                placeholder="Please provide your USDT Lock-up Address"
              ></el-input>
            </el-form-item>
          </div>
          <div class="putext">
            <div class="putflex">
              <div class="puttit puttit1">select network:</div>
              <el-form-item label="" prop="coinType" class="putgroup">
                <el-radio-group v-model="form.coinType">
                  <el-radio class="radiaos" :label="1" :disabled="radioDisabled"
                    >BNB</el-radio
                  >
                  <el-radio class="radiaos" :label="2" :disabled="radioDisabled"
                    >ERC-20</el-radio
                  >
                  <el-radio class="radiaos" :label="3" :disabled="radioDisabled"
                    >TRC-20</el-radio
                  >
                  <!-- <el-radio label="BNB"></el-radio>
                <el-radio label="ERC-20"></el-radio>
                <el-radio label="TRC-20"></el-radio> -->
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <!-- <div class="putext" style="margin-top: 40px">
            <div class="bindtit">
              <div class="dian">.</div>
              DO Lock-up Address:
            </div>
            <el-form-item prop="address">
              <el-input
                v-model="form.email"
                class="inpttext"
                :readonly="formReadOnly"
                placeholder="Please provide your DO Lock-up Address"
              ></el-input>
            </el-form-item>
          </div>
          <div class="putext">
            <div class="putflex">
              <div class="puttit">select network:</div>
              <el-form-item label="" class="putgroup">
                <el-radio-group v-model="form.do">
                  
                  <el-radio :label="1" :disabled="radioDisabled"
                    >DO Network</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>
          </div> -->
          <div class="putext" style="margin-top: 40px">
            <div class="bindtit">
              <div class="dian">.</div>
              <div>Token/NFT receiving address :</div>
                <!-- <span>(For receiving PRL-X)</span>: -->
            </div>
            <el-form-item prop="xprlAddress">
              <el-input
                v-model.trim="form.xprlAddress"
                class="inpttext"
                placeholder="Please enter the locking address for DO."
              ></el-input>
            </el-form-item>
          </div>
          <div class="putext">
            <div class="putflex">
              <div class="puttit">select network:</div>
              <el-form-item label="" class="putgroup">
                <el-radio-group v-model="dotype">
                  <!-- <el-radio label="DO Network"></el-radio> -->
                  <el-radio :label="1" :disabled="radioDisabled"
                    >DO Network</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>
          </div>

          <div class="submit" @click="tijiao">Submit</div>
        </el-form>
      </div>
      <div class="Reminder">
        <div class="Remindertit">Friendly Reminder:</div>
        <div class="Remindercon">
          <div class="boxli">
            <div class="boxleft">1.</div>
            <div class="boxright">
              <span> Address Binding:</span> Once the USDT locking address and
              the Token/NFT receiving address are bound, they cannot be changed
              or bound again.
            </div>
          </div>
<!-- 
          <div class="boxli">
            <div class="boxleft">2.</div>
            <div class="boxright">
              <span> Token/NFT receiving Address:</span> Please make sure to
              fill in the correct Token/NFT receiving address. This is the token
              transfer address corresponding to the DO locking address;
              otherwise, you will not be able to receive PRL-X.
            </div>
          </div> -->
          <div class="boxli">
            <div class="boxleft">2.</div>
            <div class="boxright">
              <span> Locking Requirements:</span> USDT/DO locking must be
              operated through a personal wallet and cannot be locked directly
              through an exchange; otherwise, you will not be able to receive
              PRL-X.
            </div>
          </div>
          <div class="boxli">
            <div class="boxleft">3.</div>
            <div class="boxright">
              <span>Single Completion: </span> The locking transaction (USDT/DO)
              must be completed in one go and cannot be split into multiple
              transactions. For example, if you are locking 500U, splitting it
              into two transactions of 200U and 300U will not allow you to
              receive PRL-X.
            </div>
          </div>
          <div class="boxli">
            <div class="boxleft">4.</div>
            <div class="boxright">
              <span> Quantity Regulation: </span>The amount of USDT and DO to be
              locked must comply with the official website's regulations. For
              example, locking 500U plus 2000DO entitles you to receive
              500PRL-X, but locking 1000U plus 2000DO still only entitles you to
              receive 500PRL-X.
            </div>
          </div>
          <div class="boxli">
            <div class="boxleft">5.</div>
            <div class="boxright">
              <span> Multiple Locking:</span> Users can perform multiple locking
              operations. After each lock of 500U plus 2000DO, you can enter the
              locking transaction hash to receive 500PRL-X. Even if you perform
              a second locking with the same amount, you can still receive
              another 500PRL-X using the new transaction hash.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="BlockList-W1" v-show="bindfloag">
      <img
        class="imgs1"
        src="../../../assets/pc/Login/close.png"
        @click="close1"
      />
      <div class="bindbox">
        <div class="bindcons">
          Please confirm that your submission<br />
          information is accurate. Once<br />
          submitted and bound, modifications<br />
          will not be possible.
        </div>
        <div class="bindbtn">
          <div class="botton" @click="close1">close</div>
          <div class="botton1" @click="Confirms">Confirm</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetBind } from "@/assets/server/api";

export default {
  props: ["bflog"],
  data() {
    return {
      bfloag1: false,
      bindfloag: false,
      radioDisabled: false,
      // formReadOnly: false,
      bfloag: false,
      userIds: "",
      dotype: 1,
      coinType: "",
      xprlAddress: "",
      donationAddress: "",
      jwtToken: "",
      form: {
        xprlAddress: "",
        donationAddress: "",
        coinType: "",
      },
      rules: {
        donationAddress: [
          {
            required: true,
            message: "donationAddress  is required",
            trigger: "blur",
          },
          {
            min: 32,
            max: 44,
            message: "donationAddress address error",
            trigger: "blur",
          },
        ],
        coinType: [
          {
            required: true,
            message: "coinType  is required",
            trigger: "blur",
          },
        ],
        xprlAddress: [
          {
            required: true,
            message: "Token/NFT is required",
            trigger: "blur",
          },
          {
            min: 38,
            max: 45,
            message: "Token/NFT receiving address error",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {
    if (
      this.userId !== "" ||
      this.userId !== null ||
      this.userId !== undefined
    ) {
      this.userId = localStorage.getItem("userId");
      this.jwtToken = localStorage.getItem("jwtToken");
      // console.log(this.userId);
    }
  },
  watch: {
    deep: true,
    bflog(val) {
      this.bfloag = val;
    },
    // userId(val){
    //   this.userIds=val;
    //   console.log(this.userIds);
    // }
  },
  methods: {
    close1() {
      this.bfloag1 = false;
      this.bindfloag = false;
    },
    close() {
      this.bfloag = false;
      this.$emit("bloginflog", this.bfloag);
    },
    tijiao() {
      // console.log(this.form);
      if (this.form.coinType == 1) {
        this.coinType = "BNB";
      } else if (this.form.coinType == 2) {
        this.coinType = "ERC-20";
      } else if (this.form.coinType == 3) {
        this.coinType = "TRC-20";
      }
      this.$refs.form.validate(async (success) => {
        //    if (this.validatePassword()) {
        //  console.log(this.form.coinType);
        if (this.form.coinType == "") {
          this.$message({
            message: "This coinType are not filled in",
            type: "warning",
            customClass: "message-zindex",
          });
          return false;
        }

        if (success) {
          this.bfloag1 = true;
          this.bindfloag = true;
          // const params = {
          //   userId: localStorage.getItem("userId"),
          //   xprlAddress: this.form.xprlAddress,
          //   donationAddress: this.form.donationAddress,
          //   coinType: this.coinType,
          // };
          // console.log(params);
          // const formData = new FormData();
          // const item = params;
          // for (const key in item) {
          //   if (Object.hasOwnProperty.call(item, key)) {
          //     formData.append(key, item[key]);
          //   }
          // }
          // let data = await GetBind(formData);
          // console.log(data);
          // if (data.code == 200) {
          //   this.xprlAddress = data.result.xprlAddress;
          //   this.donationAddress = data.result.donationAddress;
          //   localStorage.setItem("isBindAddress", 1);
          //   this.$emit("xprl", this.xprlAddress);
          //   this.$emit("donation", this.donationAddress);
          //   this.$emit("isBind", 1);
          //   this.bfloag = false;
          //   localStorage.setItem("xprl", this.xprlAddress);
          //   localStorage.setItem("donation", this.donationAddress);
          // } else {
          //   // this.$message(data.result);
          //   this.$message({
          //     message: data.result,
          //     type: "warning",
          //     customClass: "message-zindex",
          //   });
          // }
        } else {
          // this.$message(" This field are not filled in ");
          this.$message({
            message: "address error",
            type: "warning",
            customClass: "message-zindex",
          });
          return false;
        }
      });
    },
    async Confirms() {
      // let config = {
      //   headers: {
      //     "Content-Type": "application/json",
      //     jwtToken: this.jwtToken,
      //   },
      // };
      const params = {
        userId: localStorage.getItem("userId"),
        address: this.form.xprlAddress,
        donationAddress: this.form.donationAddress,
        coinType: this.coinType,
      };
      //  console.log(params);
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      //  let data = await GetBind(formData,config);
      let data = await GetBind(formData);
      //  console.log(data);
      if (data.code == 200) {
        this.xprlAddress = data.result.address;
        this.donationAddress = data.result.donationAddress;
        this.coinType = data.result.coinType;
        localStorage.setItem("isBindAddress", 1);
        this.$emit("xprl", this.xprlAddress);
        this.$emit("donation", this.donationAddress);
        this.$emit("isBind", 1);
        this.$emit("coinTypes", this.coinType);
        this.bfloag = false;
        localStorage.setItem("xprl", this.xprlAddress);
        localStorage.setItem("donation", this.donationAddress);
        localStorage.setItem("coinTypes", this.coinType);
        this.bfloag1 = false;
        this.bindfloag = false;
        this.bfloag = false;
        //   bfloag1:false,
        // bindfloag: false,
        // bfloag: false,
      } else {
        // this.$message(data.result);
        this.$message({
          message: data.result,
          type: "warning",
          customClass: "message-zindex",
        });
      }
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.BlockList-W {
  width: 650px;
  height: 1000px;
  overflow-y: auto;
  // height: 1920px;
  background: #202020;
  border-radius: 20px 20px 20px 20px;
  opacity: 1;
  position: fixed;
  z-index: 99 !important;

  // border: 1px solid red;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .imgs {
    width: 36px;
    height: 36px;
    margin-left: 550px;
    margin-top: 20px;
  }
  .logintit {
    height: 48px;
    font-family: Poppins, Poppins;
    font-weight: 500;
    font-size: 32px;
    color: #ffffff;
    line-height: 48px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 10px;
    margin-left: 40px;
  }
  .logintit1 {
    font-family: Poppins, Poppins;
    font-weight: 500;
    font-size: 24px;
    color: red;
    line-height: 48px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 10px;
    margin-left: 40px;
  }
  .loginbox {
    width: 570px;
    margin: 0 auto;
    margin-top: 24px;
    .putext {
      .putflex {
        display: flex;
        // flex-wrap: wrap;
        height: 56px;
        margin-top: -10px;
        .puttit {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 24px;
          color: rgba(255, 255, 255, 0.6);

          // margin-top: 10px;
          margin-right: 10px;
          text-align: left;
          width: 180px;
        }
        .puttit1 {
          width: 240px;
        }
        .putgroup {
          display: flex;
          flex-wrap: wrap;
          text-align: left;
          margin-bottom: 6px;
        }
      }
      .bindtit {
        display: flex;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 28px;
        text-align: left;

        color: rgba(255, 255, 255, 0.6);
        .dian {
          width: 12px;
          height: 12px;
          background: #3cf6f0;
          border-radius: 1px 1px 1px 1px;
          margin-top: 16px;
          margin-right: 6px;
        }
        span {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 20px;
          display: inline-block;
        }
      }
      /deep/.el-form-item__content {
        line-height: 0px !important;
      }
      /deep/.el-radio__inner {
        background: none;
      }
      /deep/.el-radio__input.is-checked .el-radio__inner {
        background: none !important;
        border-color: #fff !important;
      }

      /deep/.el-radio__input.is-checked .el-radio__inner {
        background: none;
        font-weight: 400;
        font-size: 28px;
      }
      /deep/.el-radio__input.is-checked + .el-radio__label {
        color: #fff;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 28px;
      }
      /deep/.el-radio-group {
        line-height: 50px !important;
      }
      /deep/.el-input__inner {
        border: none;
        height: 96px;
        line-height: 30px;
        background: #202020;
        border-bottom: 1px solid #5b5b5b;
        // padding-bottom: 10px;
        padding-left: 0px;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 24px;
        color: #fff;
        border-radius: 0px !important;
        width: 570px;
      }
      /deep/.el-input__inner::placeholder {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 24px;
        color: rgba(255, 255, 255, 0.3);
        border-radius: 0px !important;
        width: 570px;
        height: 80px;
        white-space: pre-wrap; /* 使 placeholder 内容自动换行 */
        overflow-wrap: break-word; /* 当单词过长时自动换行 */
        word-break: break-all;
      }
    }
    .submit {
      width: 244px;
      height: 76px;
      line-height: 76px;
      background: #3cf6f0;
      border-radius: 162px 162px 162px 162px;

      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 28px;
      color: #151515;
      text-align: center;
      margin-left: 312px;
      margin-top: 60px;
      cursor: pointer;
    }
  }
  .Reminder {
    margin-top: 40px;
    margin-left: 40px;
    padding-bottom: 40px;
    .Remindertit {
      height: 42px;
      font-family: Poppins, Poppins;
      font-weight: 400;
      font-size: 28px;
      color: #ffffff;
      line-height: 42px;
      text-align: left;
    }
    .Remindercon {
      text-align: left;
      margin-top: 4px;
      .boxli {
        display: flex;
        .boxleft {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 24px;
          color: #a1a1a1;
        }
        .boxright {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 24px;
          color: #a1a1a1;
          line-height: 36px;
          span {
            font-weight: 800;
            font-size: 26px;
          }
        }
      }
    }
  }
}
.BlockList-W1 {
  position: fixed;
  z-index: 999999 !important;
  width: 650px;
  height: 428px;
  background: #202020;
  border-radius: 20px 20px 20px 20px;
  position: fixed;

  // border: 1px solid red;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .imgs1 {
    width: 36px;
    height: 36px;
    margin-left: 550px;
    margin-top: 20px;
  }
  .bindbox {
    width: 530px;
    margin: 0 auto;

    .bindcons {
      margin-top: 10px;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 28px;
      color: #ffffff;
      line-height: 42px;
      text-align: center;
    }
    .bindbtn {
      display: flex;
      margin-top: 60px;
      .botton {
        width: 250px;
        height: 76px;
        line-height: 76px;
        text-align: center;
        border-radius: 162px 162px 162px 162px;
        border: 2px solid #3cf6f0;
        cursor: pointer;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 30px;
        color: #3cf6f0;
        margin-right: 18px;
      }
      .botton1 {
        width: 252px;
        height: 76px;
        line-height: 76px;
        background: #3cf6f0;
        border-radius: 162px 162px 162px 162px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 30px;
        color: #151515;
      }
    }
  }
}
</style>
